"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapRichImage = exports.mapImage = exports["default"] = void 0;
var _global$__appConfig__;
var getImageVariantsKeys = function getImageVariantsKeys(image) {
  // to get all responsive dimensions names
  if (!image) return;
  var imageVariants = ["mobile", "mobilesecond"];
  return Object.keys(image).filter(function (key) {
    return imageVariants.includes(key);
  });
};
var imageQuality = (_global$__appConfig__ = global.__appConfig__) !== null && _global$__appConfig__ !== void 0 && _global$__appConfig__.prismicImageQuality ? "?q=".concat(global.__appConfig__.prismicImageQuality, "&") : "?q=70&";
var mapImage = function mapImage(image, blurhash) {
  var _image$url, _image$url2;
  if (!image) return;
  var correctBlurhash = blurhash ? blurhash.length > 0 ? blurhash : false : false;
  var imageVariantsKeys = getImageVariantsKeys(image);
  var mappedImage = {
    altText: image.alt,
    originalSrc: (_image$url = image.url) === null || _image$url === void 0 ? void 0 : _image$url.replace(/\?/, imageQuality),
    blurhash: (correctBlurhash === null || correctBlurhash === void 0 ? void 0 : correctBlurhash.length) === 28 ? correctBlurhash : false,
    variants: [{
      name: "natural",
      aspectRatio: image.dimensions ? image.dimensions.width / image.dimensions.height : 1,
      srcset: [{
        url: (_image$url2 = image.url) === null || _image$url2 === void 0 ? void 0 : _image$url2.replace(/\?/, imageQuality),
        w: image.dimensions && image.dimensions.width,
        h: image.dimensions && image.dimensions.height
      }]
    }]
  };
  var imageVariants = imageVariantsKeys.map(function (variant) {
    var _image$variant, _image$variant$url, _image$variant2, _image$variant2$dimen, _image$variant3, _image$variant3$dimen;
    return {
      name: variant,
      srcset: [{
        url: (_image$variant = image[variant]) === null || _image$variant === void 0 ? void 0 : (_image$variant$url = _image$variant.url) === null || _image$variant$url === void 0 ? void 0 : _image$variant$url.replace(/\?/, imageQuality),
        w: (_image$variant2 = image[variant]) === null || _image$variant2 === void 0 ? void 0 : (_image$variant2$dimen = _image$variant2.dimensions) === null || _image$variant2$dimen === void 0 ? void 0 : _image$variant2$dimen.width,
        h: (_image$variant3 = image[variant]) === null || _image$variant3 === void 0 ? void 0 : (_image$variant3$dimen = _image$variant3.dimensions) === null || _image$variant3$dimen === void 0 ? void 0 : _image$variant3$dimen.height
      }]
    };
  });
  imageVariants.length > 0 && mappedImage.variants.push(imageVariants[0]);
  imageVariants.length > 1 && mappedImage.variants.push(imageVariants[1]);
  return mappedImage;
};
exports.mapImage = mapImage;
var mapRichImage = function mapRichImage(image) {
  var _image$blurhash;
  var mappedImage = {};
  mappedImage.image = mapImage(image.image, ((_image$blurhash = image.blurhash) === null || _image$blurhash === void 0 ? void 0 : _image$blurhash.length) && image.blurhash[0].text);
  mappedImage.title = image.title && image.title[0].text;
  mappedImage.link = image.url ? image.url.url : "/";
  mappedImage.tags = image.tags ? image.tags[0].text.replace(" ", "").split(",") : [];
  return mappedImage;
};
exports.mapRichImage = mapRichImage;
var _default = mapImage;
exports["default"] = _default;